import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "games-filter games-filter--desktop" }
const _hoisted_2 = { class: "games-filter__group" }
const _hoisted_3 = {
  key: 0,
  class: "games-filter__option-number"
}

import { computed, ref } from "vue";
import { useGamesGrid } from "@/games/composables/use-games-grid";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import GamesFilterCategoryOptions from "./games-filter-category-options.vue";
import GamesSortOptions from "./games-sort-options.vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { vClickOutside } from "@sazka/utils/directives/v-click-outside";
import { GamesFilterType } from "@/games/models/games-filter-type";
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { GamesFilterCategory } from "@/games/models/games-filter-options";


export default /*@__PURE__*/_defineComponent({
  __name: 'games-filter-desktop',
  setup(__props) {

const { reloadWithFilter, filterOptions, filterParameters, getFilterSortTypeLabel } = useGamesGrid();

const filterCategories = computed(() => [
    {
        category: GamesFilterType.Genres,
        text: "Žánr",
    },
    {
        category: GamesFilterType.Manufacturers,
        text: "Výrobce",
    },
    {
        category: GamesFilterType.Reels,
        text: "Počet válců",
    },
    {
        category: GamesFilterType.Lines,
        text: "Počet linií",
    },
]);

const openFilterCategory = ref<GamesFilterType>(null);
const isSortOpen = ref(false);
const sortLabel = ref<string>("Seřadit");
const showSortLabel = useBreakpoints("sm2");

const toggleFilter = (category: GamesFilterType) => {
    if (category === openFilterCategory.value) {
        openFilterCategory.value = null;
    } else {
        isSortOpen.value = false;
        openFilterCategory.value = category;
        GamesAnalytics.pushDesktopFilterOpen(category);
    }
};

const toggleSort = () => {
    if (!isSortOpen.value) {
        openFilterCategory.value = null;
    }

    isSortOpen.value = !isSortOpen.value;
};

const closeSort = () => {
    sortLabel.value = getFilterSortTypeLabel(filterParameters.value.sortType);
    isSortOpen.value = false;
};

const handleClickOutside = () => {
    openFilterCategory.value = null;
    isSortOpen.value = false;
};

const applyFilter = async (type: GamesFilterType, item: GamesFilterCategory) => {
    const allAppliedFilterNames = GamesAnalytics.getFilterOptionNames(
        filterParameters.value.genres,
        filterParameters.value.manufacturers,
        filterParameters.value.reels,
        filterParameters.value.lines,
        filterOptions.value
    );

    if (filterParameters.value[type].includes(item.guid)) {
        GamesAnalytics.pushFilterApplied(type, item.name, allAppliedFilterNames);
    } else {
        GamesAnalytics.pushFilterRemoved(type, [item.name], allAppliedFilterNames);
    }

    await reloadWithFilter();
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCategories.value, (filter) => {
        return (_openBlock(), _createElementBlock("div", {
          key: filter.category,
          class: _normalizeClass(["games-filter__option", {
                    'games-filter__option--open': openFilterCategory.value === filter.category,
                    'games-filter__option--small': _unref(filterOptions)[filter.category].length < 10,
                }])
        }, [
          _createVNode(DsButton, {
            type: "interaction",
            size: "sm",
            theme: "dark",
            "icon-right": "chevron-down",
            onClick: ($event: any) => (toggleFilter(filter.category))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(filter.text) + " ", 1),
              (_unref(filterParameters)[filter.category]?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(filterParameters)[filter.category].length), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          (openFilterCategory.value === filter.category)
            ? (_openBlock(), _createBlock(GamesFilterCategoryOptions, {
                key: 0,
                class: "games-filter__option-dialog",
                options: _unref(filterOptions)[filter.category],
                modelValue: _unref(filterParameters)[filter.category],
                "onUpdate:modelValue": ($event: any) => ((_unref(filterParameters)[filter.category]) = $event),
                name: filter.category,
                onFilterChanged: (item) => applyFilter(filter.category, item)
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "name", "onFilterChanged"]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["games-filter__option games-filter__option--sort", { 'games-filter__option--open': isSortOpen.value }])
    }, [
      (_unref(showSortLabel))
        ? (_openBlock(), _createBlock(DsButton, {
            key: 0,
            type: "interaction",
            size: "sm",
            theme: "dark",
            "icon-left": "sort-by",
            onClick: toggleSort
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(sortLabel.value), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(DsButton, {
            key: 1,
            type: "interaction",
            size: "sm",
            theme: "dark",
            "icon-left": "sort-by",
            onClick: toggleSort
          })),
      (isSortOpen.value)
        ? (_openBlock(), _createBlock(GamesSortOptions, {
            key: 2,
            class: "games-filter__option-dialog games-filter__option-dialog--sort",
            onSortApplied: closeSort
          }))
        : _createCommentVNode("", true)
    ], 2)
  ])), [
    [_unref(vClickOutside), handleClickOutside]
  ])
}
}

})